import * as Styled from './list-skeleton.style';

export const ListItemSkeleton = () => (
  <Styled.ListItem>
    <Styled.ListItemImage />
    <Styled.ListItemContent>
      <Styled.ListItemText />
      <Styled.ListItemText $isSmall $marginBottom={0} />
    </Styled.ListItemContent>
  </Styled.ListItem>
);

export const ListSkeleton = () => (
  <>
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
    <ListItemSkeleton />
  </>
);
